import{createElement as e}from"../../../../external/preact/dist/preact.js";const t=({label:t})=>e("span",{className:"checkout-secondary-button__text"},t);export{t as default};
